/**
 * Phase 6 Plan 02 — useInspectionAuditTrail (HIST-5.3, D-136).
 *
 * Lazy GET /api/admin/inspections/{id}/audit (PM-only; cookie-bound). Enabled
 * only when the parent component decides — typically `enabled = rowExpanded
 * && pm_edit_count > 0` so the network call only fires for rows that have
 * audit history AND are being viewed.
 *
 * Server returns rows ordered ASC by edited_at + id ASC tie-break (HIST-5.3
 * verbatim — oldest-first).
 *
 * staleTime: 30s mirrors Plan 04-04 useAssetInspections precedent.
 */
import { useQuery } from "@tanstack/react-query";
import { apiGet, ApiError } from "../../api/client";
import {
  INSPECTION_AUDIT_KEY,
  type InspectionAuditTrailResponse,
} from "../../api/inspections";

export function useInspectionAuditTrail(inspectionId: number, enabled: boolean) {
  return useQuery<InspectionAuditTrailResponse, ApiError>({
    queryKey: INSPECTION_AUDIT_KEY(inspectionId),
    queryFn: () =>
      apiGet<InspectionAuditTrailResponse>(
        `/api/admin/inspections/${inspectionId}/audit`,
      ),
    enabled: enabled && inspectionId > 0,
    staleTime: 30_000,
  });
}
